module.exports = __webpack_public_path__ + "img/face-tired.676d892f.svg";